import React from "react";
import { IntlProvider } from "react-intl";
import zhCN from "./src/i18n/locales/zh-CN.json";

export const wrapRootElement = ({ element }) => (
  <IntlProvider locale="zh-CN" messages={zhCN}>
    {element}
  </IntlProvider>
);